// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e24f96a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/apps/sai/MySai.vue
// module id = 1266
// module chunks = 0